export default __webpack_public_path__ + "static/media/mui-eye.020336ac.svg";